import { Outlet, Route } from '@tanstack/router'

import { rootRoute } from '../root'

export const blogRoute = new Route({
  getParentRoute: () => rootRoute,
  path: 'blogs',
  component: Outlet,
})
